const formTables = document.getElementsByClassName('js-form-pro-table');

for (let index = 0; index < formTables.length; index++) {
  const table = formTables[index];
  const formPro = table.closest('.gform_wrapper');
  if (!formPro) continue;

  formPro.classList.add('gform_wrapper--pro')

  const resume = formPro.querySelector('.js-form-pro-resume');
  const footer = formPro.querySelector('.gform_footer');

  //move resume into footer
  resume.removeAttribute('style');
  footer.insertAdjacentElement('afterbegin', resume);

  const totalPrices = formPro.querySelector('.js-form-pro-prices');
  const totalSeats = formPro.querySelector('.js-form-pro-seats');
  const lines = [...formPro.getElementsByClassName('js-form-pro-line')];

  const calcTotals = () => {
    let prices = 0;
    let seats = 0;

    lines.forEach((line) => {
      const input = line.querySelector('input');
      if (input) {
        const price = parseInt(line.dataset.price);
        seats += parseInt(input.value)
        prices += parseInt(input.value) * price
      }
    })

    totalPrices.textContent = prices;
    totalSeats.textContent = seats;
  }

  lines.forEach((line) => {
    const price = parseInt(line.dataset.price);
    const input = line.querySelector('input');
    if (input) {
      const total = line.querySelector('.js-form-pro-total')
      input.addEventListener('input', () => {
        total.textContent = parseInt(input.value) * price
        calcTotals()
      })
    }
  })
}
